// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"533cabb0","127":"bb3ddda5","453":"cd7146f6","834":"3f9e7d06"}[chunkId] + ".chunk.js";
};